import React from 'react'
import { Link } from 'react-router-dom'

function PrivacyPolicy() {
    return (
        <>
            <section className='other-pages'>
                <div className="container">
                    <h3>Privacy Policy</h3>
                </div>
            </section>
            <section className='other-pages-details'>
                <div className="container">
                    <h6 className='mb-4'>This privacy policy applies to the Daily simply Nutritions Tips app (hereby referred to as "Application") for
                        mobile devices that was created by Daily Simply Nutritions Tips (hereby referred to as "Service Provider") as a Free
                        service. This service is intended for use "AS IS".</h6>
                    <div className='mb-3'>
                        <h5 className='mb-3'>1. Information Collection and Use</h5>
                        <h6>The Application collects information when you download and use it. This information may include information such as.</h6>
                        <ul>
                            <li>Your device's Internet Protocol address (e.g. IP address)</li>
                            <li>The pages of the Application that you visit, the time and date of your visit, the time spent on those pages</li>
                            <li>The time spent on the Application</li>
                            <li>The operating system you use on your mobile device</li>
                        </ul>
                    </div>

                    <div className='mb-3'>
                        <h6 className='mb-2'>The Application does not gather precise information about the location of your mobile device.</h6>
                        <h6 className='mb-3'>The Application collects your device's location, which helps the Service Provider determine your approximate
                            geographical location and make use of in below ways:</h6>
                        <ul className='mb-3'>
                            <li>Geolocation Services: The Service Provider utilizes location data to provide features such as personalized
                                content, relevant recommendations, and location-based services.</li>
                            <li>Analytics and Improvements: Aggregated and anonymized location data helps the Service Provider to analyze user
                                behavior, identify trends, and improve the overall performance and functionality of the Application.</li>
                            <li>Third-Party Services: Periodically, the Service Provider may transmit anonymized location data to external
                                services. These services assist them in enhancing the Application and optimizing their offerings.</li>
                        </ul>

                        <h6 className='mb-2'>The Service Provider may use the information you provided to contact you from time to time to provide you with
                            important information, required notices and marketing promotions.</h6>

                        <h6>For a better experience, while using the Application, the Service Provider may require you to provide us with
                            certain personally identifiable information. The information that the Service Provider request will be retained by
                            them and used as described in this privacy policy.</h6>
                    </div>
                    <div className='mb-3 mt-3 mt-md-5'>
                        <h5 className='mb-3'>2. Third Party Access</h5>
                        <h6 className='mb-3'>Only aggregated, anonymized data is periodically transmitted to external services to aid the Service Provider in
                            improving the Application and their service. The Service Provider may share your information with third parties in
                            the ways that are described in this privacy statement.</h6>
                        <h6 className='mb-3'>The Service Provider may disclose User Provided and Automatically Collected Information:</h6>

                        <ul className='mb-3'>
                            <li>as required by law, such as to comply with a subpoena, or similar legal process;</li>
                            <li>when they believe in good faith that disclosure is necessary to protect their rights, protect your safety or the
                                safety of others, investigate fraud, or respond to a government request;</li>
                            <li>with their trusted services providers who work on their behalf, do not have an independent use of the
                                information we disclose to them, and have agreed to adhere to the rules set forth in this privacy statement.</li>
                        </ul>
                    </div>

                    <div className='mb-3 mt-3 mt-md-5'>
                        <h5 className='mb-3'>3. Opt-Out Rights</h5>
                        <h6 className='mb-3'>You can stop all collection of information by the Application easily by uninstalling it. You may use the standard
                            uninstall processes as may be available as part of your mobile device or via the mobile application marketplace or
                            network.</h6>
                    </div>

                    <div className='mb-3 mt-3 mt-md-5'>
                        <h5 className='mb-3'>4. Data Retention Policy</h5>
                        <h6 className='mb-3'>The Service Provider will retain User Provided data for as long as you use the Application and for a reasonable
                            time thereafter. If you'd like them to delete User Provided Data that you have provided via the Application, please
                            contact them at <Link to="mailto:hello@downloadsimply.com.">hello@downloadsimply.com.</Link> and they will respond in a reasonable time.</h6>
                    </div>

                    <div className='mb-3 mt-3 mt-md-5'>
                        <h5 className='mb-3'>5. Children</h5>
                        <h6 className='mb-3'>The Service Provider does not use the Application to knowingly solicit data from or market to children under the
                            age of 13.</h6>
                        <h6 className='mb-3'>The Service Provider does not knowingly collect personally
                            identifiable information from children. The Service Provider
                            encourages all children to never submit any personally
                            identifiable information through the Application and/or Services.
                            The Service Provider encourage parents and legal guardians to monitor
                            their children's Internet usage and to help enforce this Policy by instructing
                            their children never to provide personally identifiable information through the Application and/or Services
                            without their permission. If you have reason to believe that a child
                            has provided personally identifiable information to the Service Provider through the Application and/or Services,
                            please contact the Service Provider <Link to="mailto:hello@downloadsimply.com.">hello@downloadsimply.com.</Link> so that they will be able to take the necessary
                            actions.
                            You must also be at least 16 years of age to consent to the processing
                            of your personally identifiable information in your country (in some countries we may allow your parent
                            or guardian to do so on your behalf).</h6>
                    </div>

                    <div className='mb-3 mt-3 mt-md-5'>
                        <h5 className='mb-3'>6. Security</h5>
                        <h6 className='mb-3'>The Service Provider is concerned about safeguarding the confidentiality of your information. The Service Provider
                            provides physical, electronic, and procedural safeguards to protect information the Service Provider processes and
                            maintains.</h6>
                    </div>

                    <div className='mb-3 mt-3 mt-md-5'>
                        <h5 className='mb-3'>7. Changes</h5>
                        <h6 className='mb-3'>This Privacy Policy may be updated from time to time for any reason. The Service Provider will notify you of any
                            changes to the Privacy Policy by updating this page with the new Privacy Policy. You are advised to consult this
                            Privacy Policy regularly for any changes, as continued use is deemed approval of all changes.</h6>
                        <h6 className='mb-3'>This privacy policy is effective as of 2025-04-16</h6>
                    </div>

                    <div className='mb-3 mt-3 mt-md-5'>
                        <h5 className='mb-3'>8. Your Consent</h5>
                        <h6 className='mb-3'>By using the Application, you are consenting to the processing of your information as set forth in this Privacy
                        Policy now and as amended by us.</h6>
                    </div>

                    <div className='mb-3 mt-3 mt-md-5'>
                        <h5 className='mb-3'>9. Contact Us</h5>
                        <h6 className='mb-3'>If you have any questions regarding privacy while using the Application, or have questions about the practices,
                        please contact the Service Provider via email at <Link to="mailto:hello@downloadsimply.com.">hello@downloadsimply.com.</Link></h6>
                    </div>
                </div>
            </section>
        </>
    )
}

export default PrivacyPolicy